module.exports = __webpack_public_path__ + "img/success5.eb0d3e36.gif";